export default "__VITE_ASSET__DavJ2MTB__"